export const SENTRY_RELEASE: string | undefined = 'ec68e799fc5f0ed8b1a5ca8554e82c33a5e711ae';
